import { useEffect, useState } from 'react';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/api/personel';
const token = () => localStorage.getItem('token');
const hdr = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` });

const ATAMA_TUR: Record<string, { label: string; renk: string; bg: string; ikon: string }> = {
  ilk_atama:     { label: 'İlk Atama',       renk: '#1e40af', bg: '#dbeafe', ikon: '🏷️' },
  nakil:         { label: 'Nakil',            renk: '#065f46', bg: '#d1fae5', ikon: '↔️' },
  gorevlendirme: { label: 'Görevlendirme',   renk: '#92400e', bg: '#fef3c7', ikon: '📋' },
  vekaleten:     { label: 'Vekaleten',        renk: '#6b21a8', bg: '#f5f3ff', ikon: '🔄' },
  ikincil_gorev: { label: 'İkincil Görev',   renk: '#374151', bg: '#f3f4f6', ikon: '📌' },
};

const BOŞ_ATAMA = {
  personel_id: '', atama_turu: 'nakil',
  onceki_birim: '', yeni_birim: '',
  onceki_isletme_id: '', yeni_isletme_id: '',
  atama_tarihi: '', baslama_tarihi: '', bitis_tarihi: '',
  atama_no: '', onay_tarihi: '', aciklama: '',
};

export default function PersonelAtama() {
  const [liste, setListe] = useState<any[]>([]);
  const [personeller, setPersoneller] = useState<any[]>([]);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [form, setForm] = useState<any>(null);
  const [secilenPersonel, setSecilenPersonel] = useState<string>('');
  const [secilenTur, setSecilenTur] = useState<string>('');
  const [zaman, setZaman] = useState<any>(null);

  useEffect(() => {
    yukle();
    fetch(`${API}/?durum=aktif`, { headers: hdr() }).then(r => r.json()).then(setPersoneller);
    fetch((process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/api/isletmeler', { headers: hdr() }).then(r => r.json()).then(d => setIsletmeler(Array.isArray(d) ? d : d.isletmeler || []));
  }, []);

  function yukle(personel_id = secilenPersonel, tur = secilenTur) {
    const p = new URLSearchParams();
    if (personel_id) p.set('personel_id', personel_id);
    if (tur) p.set('atama_turu', tur);
    fetch(`${API}/atama/liste?${p}`, { headers: hdr() }).then(r => r.json()).then(setListe);
  }

  async function kaydet() {
    const method = form.id ? 'PUT' : 'POST';
    const url = form.id ? `${API}/atama/${form.id}` : `${API}/atama`;
    const veri = { ...form };
    veri.personel_id = Number(veri.personel_id);
    if (!veri.personel_id) return alert('Personel seçiniz');
    ['onceki_isletme_id', 'yeni_isletme_id'].forEach(k => {
      veri[k] = veri[k] ? Number(veri[k]) : null;
    });
    ['bitis_tarihi', 'onay_tarihi'].forEach(k => { if (!veri[k]) veri[k] = null; });
    await fetch(url, { method, headers: hdr(), body: JSON.stringify(veri) });
    setForm(null);
    yukle();
  }

  async function sil(id: number) {
    if (!confirm('Bu atama kaydını silmek istiyor musunuz?')) return;
    await fetch(`${API}/atama/${id}`, { method: 'DELETE', headers: hdr() });
    yukle();
  }

  async function zamanCizgisi(personelId: string) {
    if (zaman?.personelId === personelId) { setZaman(null); return; }
    const veriler = await fetch(`${API}/atama/liste?personel_id=${personelId}`, { headers: hdr() }).then(r => r.json());
    const personel = personeller.find(p => p.id === Number(personelId));
    setZaman({ personelId, veriler, personel });
  }

  const turRenkleri = Object.entries(ATAMA_TUR);

  return (
    <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#111827' }}>Atama & Nakil Yönetimi</h2>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: '#6b7280' }}>İlk atama · Nakil · Görevlendirme · Vekaleten · İkincil Görev</p>
        </div>
        <button onClick={() => setForm({ ...BOŞ_ATAMA })} style={{
          background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8,
          padding: '10px 20px', cursor: 'pointer', fontWeight: 600, fontSize: 14,
        }}>+ Yeni Atama</button>
      </div>

      {/* TÜR ROZETLERİ */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 18, flexWrap: 'wrap' }}>
        {turRenkleri.map(([k, v]) => (
          <button key={k} onClick={() => { setSecilenTur(secilenTur === k ? '' : k); yukle(secilenPersonel, secilenTur === k ? '' : k); }}
            style={{ background: secilenTur === k ? v.bg : '#f9fafb', color: secilenTur === k ? v.renk : '#374151', border: `1px solid ${secilenTur === k ? v.renk : '#e5e7eb'}`, borderRadius: 20, padding: '4px 12px', cursor: 'pointer', fontSize: 13, fontWeight: 600, transition: 'all 0.15s' }}>
            {v.ikon} {v.label}
          </button>
        ))}
        {secilenTur && <button onClick={() => { setSecilenTur(''); yukle(secilenPersonel, ''); }} style={{ background: 'none', border: '1px solid #e5e7eb', borderRadius: 20, padding: '4px 10px', cursor: 'pointer', fontSize: 12, color: '#6b7280' }}>✕ Temizle</button>}
      </div>

      {/* PERSONEL FİLTRE */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
        <select value={secilenPersonel} onChange={e => { setSecilenPersonel(e.target.value); yukle(e.target.value, secilenTur); }} style={{ ...selectSt, maxWidth: 280 }}>
          <option value="">Tüm Personel</option>
          {personeller.map(p => <option key={p.id} value={p.id}>{p.ad} {p.soyad} ({p.sicil_no})</option>)}
        </select>
        {secilenPersonel && (
          <button onClick={() => zamanCizgisi(secilenPersonel)} style={{
            background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe',
            borderRadius: 8, padding: '6px 14px', cursor: 'pointer', fontWeight: 600, fontSize: 13,
          }}>📅 Zaman Çizelgesi</button>
        )}
      </div>

      {/* ZAMAN ÇİZELGESİ */}
      {zaman && (
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #bfdbfe', padding: 20, marginBottom: 20 }}>
          <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 14, color: '#1d4ed8' }}>
            📅 {zaman.personel?.ad} {zaman.personel?.soyad} — Kariyer Zaman Çizelgesi
          </div>
          <div style={{ position: 'relative', paddingLeft: 24 }}>
            <div style={{ position: 'absolute', left: 8, top: 0, bottom: 0, width: 2, background: '#bfdbfe' }} />
            {zaman.veriler.map((a: any, i: number) => {
              const t = ATAMA_TUR[a.atama_turu] || { label: a.atama_turu, renk: '#374151', bg: '#f3f4f6', ikon: '•' };
              return (
                <div key={a.id} style={{ position: 'relative', marginBottom: 16 }}>
                  <div style={{ position: 'absolute', left: -20, top: 4, width: 12, height: 12, borderRadius: '50%', background: t.renk, border: '2px solid #fff', boxShadow: '0 0 0 2px ' + t.renk }} />
                  <div style={{ background: t.bg, border: `1px solid ${t.renk}30`, borderRadius: 8, padding: '10px 14px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontWeight: 700, color: t.renk, fontSize: 13 }}>{t.ikon} {t.label}</span>
                      <span style={{ fontSize: 11, color: '#6b7280' }}>{a.atama_tarihi}</span>
                    </div>
                    {a.onceki_birim && <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>Önceki: {a.onceki_birim}</div>}
                    <div style={{ fontSize: 12, color: '#374151', marginTop: 2 }}>Yeni: {a.yeni_birim || '—'}{a.bitis_tarihi ? ` (–${a.bitis_tarihi})` : ''}</div>
                    {a.atama_no && <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>Karar: {a.atama_no}</div>}
                  </div>
                </div>
              );
            })}
            {zaman.veriler.length === 0 && <div style={{ color: '#9ca3af', fontSize: 13 }}>Atama kaydı bulunamadı.</div>}
          </div>
        </div>
      )}

      {/* ATAMA LİSTESİ */}
      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
        {liste.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#9ca3af' }}>Atama kaydı bulunamadı.</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                {['Atama Türü', 'Personel', 'Önceki Birim', 'Yeni Birim', 'Atama Tarihi', 'Başlama', 'Bitiş', 'Atama No', ''].map(h => (
                  <th key={h} style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: '#374151', fontSize: 12 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {liste.map((a, i) => {
                const t = ATAMA_TUR[a.atama_turu] || { label: a.atama_turu, renk: '#374151', bg: '#f3f4f6', ikon: '•' };
                const p = personeller.find(x => x.id === a.personel_id);
                const bugun = new Date().toISOString().slice(0, 10);
                const aktifGorev = a.atama_turu === 'gorevlendirme' && a.bitis_tarihi && a.bitis_tarihi < bugun;
                return (
                  <tr key={a.id} style={{ borderBottom: '1px solid #f3f4f6', background: aktifGorev ? '#fef9c3' : i % 2 === 0 ? '#fff' : '#fafafa' }}>
                    <td style={{ padding: '9px 14px' }}>
                      <span style={{ background: t.bg, color: t.renk, fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 6 }}>
                        {t.ikon} {t.label}
                      </span>
                      {aktifGorev && <span style={{ marginLeft: 4, fontSize: 10, color: '#92400e', fontWeight: 700 }}>SÜRESİ GEÇTİ</span>}
                    </td>
                    <td style={{ padding: '9px 14px', fontWeight: 600 }}>{p ? `${p.ad} ${p.soyad}` : `#${a.personel_id}`}</td>
                    <td style={{ padding: '9px 14px', color: '#6b7280', fontSize: 12 }}>{a.onceki_birim || '—'}</td>
                    <td style={{ padding: '9px 14px', color: '#374151', fontWeight: 500 }}>{a.yeni_birim || '—'}</td>
                    <td style={{ padding: '9px 14px', fontFamily: 'monospace', fontSize: 12 }}>{a.atama_tarihi || '—'}</td>
                    <td style={{ padding: '9px 14px', fontFamily: 'monospace', fontSize: 12 }}>{a.baslama_tarihi || '—'}</td>
                    <td style={{ padding: '9px 14px', fontFamily: 'monospace', fontSize: 12, color: aktifGorev ? '#991b1b' : '#374151' }}>{a.bitis_tarihi || '—'}</td>
                    <td style={{ padding: '9px 14px', color: '#6b7280', fontSize: 12 }}>{a.atama_no || '—'}</td>
                    <td style={{ padding: '9px 14px' }}>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button onClick={() => setForm({ ...a })} style={kücükBtnSt}>Düzenle</button>
                        <button onClick={() => sil(a.id)} style={{ ...kücükBtnSt, color: '#991b1b', borderColor: '#fecaca' }}>Sil</button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {/* FORM MODALI */}
      {form && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 28, width: 680, maxHeight: '90vh', overflow: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>{form.id ? 'Atama Güncelle' : 'Yeni Atama Ekle'}</h3>
              <button onClick={() => setForm(null)} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#9ca3af' }}>✕</button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Alan etiket="Personel *">
                <select value={form.personel_id} onChange={e => setForm({ ...form, personel_id: e.target.value })} style={selectSt}>
                  <option value="">Seçiniz</option>
                  {personeller.map(p => <option key={p.id} value={p.id}>{p.ad} {p.soyad} — {p.sicil_no}</option>)}
                </select>
              </Alan>
              <Alan etiket="Atama Türü *">
                <select value={form.atama_turu} onChange={e => setForm({ ...form, atama_turu: e.target.value })} style={selectSt}>
                  {Object.entries(ATAMA_TUR).map(([k, v]) => <option key={k} value={k}>{v.ikon} {v.label}</option>)}
                </select>
              </Alan>
              <Alan etiket="Önceki Birim"><input value={form.onceki_birim} onChange={e => setForm({ ...form, onceki_birim: e.target.value })} style={inputSt} /></Alan>
              <Alan etiket="Yeni Birim"><input value={form.yeni_birim} onChange={e => setForm({ ...form, yeni_birim: e.target.value })} style={inputSt} /></Alan>
              <Alan etiket="Önceki İşletme">
                <select value={form.onceki_isletme_id || ''} onChange={e => setForm({ ...form, onceki_isletme_id: e.target.value })} style={selectSt}>
                  <option value="">Merkez</option>
                  {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                </select>
              </Alan>
              <Alan etiket="Yeni İşletme">
                <select value={form.yeni_isletme_id || ''} onChange={e => setForm({ ...form, yeni_isletme_id: e.target.value })} style={selectSt}>
                  <option value="">Merkez</option>
                  {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                </select>
              </Alan>
              <Alan etiket="Atama Tarihi *"><input type="date" value={form.atama_tarihi} onChange={e => setForm({ ...form, atama_tarihi: e.target.value })} style={inputSt} /></Alan>
              <Alan etiket="Göreve Başlama"><input type="date" value={form.baslama_tarihi} onChange={e => setForm({ ...form, baslama_tarihi: e.target.value })} style={inputSt} /></Alan>
              <Alan etiket="Bitiş Tarihi (geçici görev)"><input type="date" value={form.bitis_tarihi} onChange={e => setForm({ ...form, bitis_tarihi: e.target.value })} style={inputSt} /></Alan>
              <Alan etiket="Onay Tarihi"><input type="date" value={form.onay_tarihi} onChange={e => setForm({ ...form, onay_tarihi: e.target.value })} style={inputSt} /></Alan>
              <Alan etiket="Karar / Atama No"><input value={form.atama_no} onChange={e => setForm({ ...form, atama_no: e.target.value })} style={inputSt} placeholder="Örn: 2025/123" /></Alan>
            </div>
            <div style={{ marginTop: 14 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Açıklama</label>
              <textarea value={form.aciklama} onChange={e => setForm({ ...form, aciklama: e.target.value })} style={{ ...inputSt, height: 70, resize: 'vertical' }} />
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20 }}>
              <button onClick={() => setForm(null)} style={{ padding: '9px 20px', border: '1px solid #d1d5db', borderRadius: 8, background: '#f3f4f6', color: '#374151', cursor: 'pointer', fontWeight: 600 }}>İptal</button>
              <button onClick={kaydet} style={{ padding: '9px 20px', border: 'none', borderRadius: 8, background: '#1d4ed8', color: '#fff', cursor: 'pointer', fontWeight: 600 }}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function Alan({ etiket, children }: { etiket: string; children: React.ReactNode }) {
  return (
    <div>
      <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>{etiket}</label>
      {children}
    </div>
  );
}

const inputSt: React.CSSProperties = { width: '100%', padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 7, fontSize: 13, boxSizing: 'border-box' };
const selectSt: React.CSSProperties = { ...inputSt, background: '#fff' };
const kücükBtnSt: React.CSSProperties = { background: 'none', border: '1px solid #d1d5db', borderRadius: 6, padding: '3px 10px', cursor: 'pointer', fontSize: 12, color: '#374151' };
